const Rows = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 4.5A2.5 2.5 0 0 1 19.5 7v10a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 17V7A2.5 2.5 0 0 1 7 4.5zM18.5 7A1.5 1.5 0 0 0 17 5.5H7A1.5 1.5 0 0 0 5.5 7v4.5h13zm0 5.5h-13V17A1.5 1.5 0 0 0 7 18.5h10a1.5 1.5 0 0 0 1.5-1.5z"
      clipRule="evenodd"
    />
  </>
)
export default Rows
